import { Button } from "@/components/Button";
import WalletInput from "../WalletInput";
import styles from "./styles.module.sass";
import { observer } from "mobx-react-lite";
import { walletStore } from "@/store";
import { balance } from "@/utils";
import { useEffect, useState } from "react";
import { useSuiClient } from "@mysten/dapp-kit";
import { useNavigate } from "react-router-dom";
import { externalLink, isIOS } from "@/utils/handleExpandPage";
import { Transaction } from "@mysten/sui/transactions";
import { MIST_PER_SUI } from "@mysten/sui/utils";

let timeout: NodeJS.Timeout | null = null;

const SendToAdderess = observer(() => {
  const [amount, setAmount] = useState<string>();
  const [address, setAddress] = useState<string>();
  const [isAddressValid, setIsAddressValid] = useState<boolean>(false);
  const isAmoutValid =
    Number(amount) > 0 && Number(amount) <= +balance(walletStore.balance);
  const client = useSuiClient();
  const navigate = useNavigate();
  const currentAccAddress = walletStore.address;

  const focus = () => {
    navigate("/wallet", { replace: true });
  };

  useEffect(() => {
    return () => {
      clearTimeout(timeout!);
      window.removeEventListener("focus", focus);
    };
  }, []);

  return (
    <div className={styles.sendToAdderessWrapper}>
      <div className={styles.walletFinanceBlock}>
        <h2 className={styles.title}>Send to wallet address</h2>
        <p className={styles.hint}>
          The funds will immediately be sent directly to the specified wallet
          address below. This transaction is final.
        </p>
        <div className={styles.form}>
          <WalletInput
            labelSize="xl"
            label="SUI amount"
            onChange={(val) => setAmount(val)}
            name="amount"
            hint={`Current balance: ${balance(walletStore.balance)} SUI`}
            error={!isAmoutValid ? "Insufficient funds" : undefined}
          />
          <WalletInput
            wrap={true}
            error={!isAddressValid ? "Invalid address" : undefined}
            label="Recipient wallet address"
            onChange={(val) => {
              clearTimeout(timeout!);
              if (val.length > 3) {
                timeout = setTimeout(() => {
                  client
                    .getBalance({
                      owner: val,
                    })
                    .then(() => {
                      setIsAddressValid(true);
                      setAddress(val);
                    })
                    .catch(() => {
                      setIsAddressValid(false);
                    });
                }, 300);
              }
            }}
            name="address"
          />
        </div>
      </div>
      <Button
        disabled={!(isAddressValid && isAmoutValid)}
        onClick={() => {
          if (walletStore.walletType === "OKX" && amount && address) {
            const handledAmount = Number(amount) * Number(MIST_PER_SUI);

            const tx = new Transaction();
            const [coin] = tx.splitCoins(tx.gas, [handledAmount]);
            tx.transferObjects([coin], address);

            const input = {
              transactionBlock: tx,
              chain: "sui:mainnet",
              options: {
                showEffects: true,
              },
            };

            console.log(walletStore.OKXSuiProvider);

            walletStore.OKXSuiProvider?.signAndExecuteTransaction(input).then(
              (result) => {
                console.log(result);
                navigate("/wallet", { replace: true });
              }
            );
          } else {
            if (isIOS) {
              window.addEventListener("focus", focus);
            }

            externalLink("/transferStashed", {
              amount: amount ?? "",
              sender: currentAccAddress ?? "",
              reciever: address ?? "",
            });
            navigate("/wallet", { replace: true });
          }
        }}
        block={true}
        label="Send to Wallet"
      />
    </div>
  );
});

export default SendToAdderess;
